module.exports = __webpack_public_path__ + "static/Student1-73f353261d3293c915a70bbdfdd61c30.jpg";